import styled from 'styled-components';

import {
   ReceptionServiceDuration,
   ReceptionServiceId,
} from '@dreryk/egabinet-private-medical-service-published-language-api';
import { Money } from '@dreryk/money-common-api';

import {
   createDynamicColumnsWidth,
   JustifyContent,
   RowDetails,
   RowDetailsCell,
   StyledFlex,
   Text,
} from '@dreryk/react-components';

import { DurationText } from '../../../shared/components/DurationText';
import { PriceText } from '../../../shared/components/PriceText';
import { SpecialtiesText } from '../../../shared/specialties/SpecialtiesText';

import { PractitionerReceptionServiceOptionsCell } from './PractitionerReceptionServiceOptionsCell';

const StyledPractitionerRowDetails = styled(RowDetails)`
   padding-left: 60px;
   padding-right: 50px;
`;

StyledPractitionerRowDetails.displayName = 'StyledPractitionerRowDetails';

type PractitionerRowDetailsProps = {
   readonly minPrice: Money;
   readonly maxPrice: Money;
   readonly practitionerReceptionServiceId: number;
   readonly practitionerName: string;
   readonly practitionerSpecialtyNames: string[];
   readonly receptionServiceName: string;
   readonly hasMorePractitioners: boolean;
   readonly receptionServiceId: ReceptionServiceId;
   readonly practitionerId: number;
   readonly estimatedDuration: ReceptionServiceDuration;
};

export const PractitionerRowDetails = (props: PractitionerRowDetailsProps): JSX.Element => {
   const columnsWidth = createDynamicColumnsWidth({
      nameWithSpecialties: '100%',
      price: '190px',
      empty: '90px',
      options: '64px',
      estimatedDuration: '130px',
   });

   return (
      <StyledPractitionerRowDetails testId={`practitioner-${props.practitionerReceptionServiceId}`}>
         <RowDetailsCell testId={'nameWithSpecialties'} width={columnsWidth.nameWithSpecialties}>
            <StyledFlex direction={'column'}>
               <Text testId={'displayName'}>{props.practitionerName}</Text>
               <SpecialtiesText specialties={props.practitionerSpecialtyNames} compact secondary />
            </StyledFlex>
         </RowDetailsCell>
         <RowDetailsCell testId={'price'} width={columnsWidth.price} justifyContent={JustifyContent.END}>
            <PriceText testId={'price'} min={props.minPrice} max={props.maxPrice} />
         </RowDetailsCell>

         <RowDetailsCell
            testId={'estimatedDuration'}
            width={columnsWidth.estimatedDuration}
            justifyContent={JustifyContent.END}
         >
            <DurationText testId={'estimatedDuration'} value={props.estimatedDuration} />
         </RowDetailsCell>

         <RowDetailsCell testId={'empty'} width={columnsWidth.empty}>
            {''}
         </RowDetailsCell>
         <RowDetailsCell testId={'options'} width={columnsWidth.options} justifyContent={JustifyContent.END}>
            <PractitionerReceptionServiceOptionsCell
               practitionerReceptionServiceId={props.practitionerReceptionServiceId}
               practitionerId={props.practitionerId}
               practitionerName={props.practitionerName}
               receptionServiceId={props.receptionServiceId}
               receptionServiceName={props.receptionServiceName}
               hasMorePractitioners={props.hasMorePractitioners}
            />
         </RowDetailsCell>
      </StyledPractitionerRowDetails>
   );
};
